<template>
  <div class="col-xl-4 xl-100">
    <px-card title="Stores performance">
      <div class="card-body p-0">
        <template v-if="stores.length">
          <div
            class="px-3 py-2 border-bottom"
            v-for="store in stores"
            :key="store.host"
          >
            <div class="d-flex align-items-center">
              <div
                class="mr-2"
                style="width:36px;height:36px;border-radius:100%;background-color:#f4f4f4;display:flex;align-items:center;justify-content:center;flex-shrink:0;"
              >
                <feather
                  type="shopping-bag"
                  style="width:16px;height:16px;color:#4680ff;"
                ></feather>
              </div>
              <div class="flex-grow-1" style="min-width:0;">
                <div class="d-flex justify-content-between align-items-center">
                  <span class="text-truncate" style="font-weight:600;" :title="store.title">
                    {{ store.title }}
                  </span>
                  <span style="font-weight:600;white-space:nowrap;">
                    {{ formatMoney(store.revenue, store.symbol) }}
                  </span>
                </div>
                <div class="d-flex justify-content-between align-items-center">
                  <small class="text-muted text-truncate" :title="store.host">
                    {{ store.host }}
                  </small>
                  <small class="text-muted" style="white-space:nowrap;">
                    {{ formatNumber(store.orders) }} orders
                  </small>
                </div>
              </div>
            </div>
            <div class="progress mt-1" style="height:5px;">
              <div
                class="progress-bar"
                :style="{ width: store.share + '%', backgroundColor: '#4680ff' }"
              ></div>
            </div>
            <div class="d-flex justify-content-between align-items-center mt-1">
              <small class="text-muted">
                <feather
                  type="shopping-cart"
                  style="width:13px;height:13px;color:#51bb25;"
                ></feather>
                {{ formatNumber(store.abandoned) }}
                <feather
                  type="alert-triangle"
                  style="width:13px;height:13px;color:#f73164;"
                  class="ml-2"
                ></feather>
                {{ formatNumber(store.lowStock) }}
              </small>
              <button class="btn btn-sm btn-light" @click="open(store)">
                Open
              </button>
            </div>
          </div>
        </template>
        <div v-else class="text-center p-4 text-muted">
          No stores yet.
        </div>
      </div>
    </px-card>
  </div>
</template>

<script>
import {
  setSelectedHost,
  formatMoney,
  formatNumber
} from "../../../utils/store-stats";

export default {
  name: "stores-overview-list",
  props: {
    stores: { type: Array, default: () => [] }
  },
  methods: {
    formatMoney,
    formatNumber,
    open(store) {
      setSelectedHost(store.host);
      this.$router.push("/dashboard/site");
    }
  }
};
</script>

<style></style>
